import type { ActivityType } from "../types/activity.types";
import { getActivityRoutes } from "./activityTypeRoutes";
import { buildPathWithStatusTabSearch } from "./statusTabNavigation";

const readCreatedId = (created: unknown): string | undefined => {
  if (!created || typeof created !== "object") return undefined;
  const id = (created as { id?: unknown }).id;
  return typeof id === "string" && id ? id : undefined;
};

/**
 * Where to land after creating an activity from a model: the new activity, or
 * the list without the Modelo tab the flow started from.
 */
export const resolveCreatedFromModelPath = (
  created: unknown,
  activityType: ActivityType | undefined,
  currentSearch: string,
): string => {
  const routes = getActivityRoutes(activityType);
  const createdId = readCreatedId(created);
  if (createdId) {
    return routes.detail(createdId);
  }
  return buildPathWithStatusTabSearch(routes.list, currentSearch, {
    status: null,
    rebalance: true,
  });
};
